// Projects.jsx (TOUCH AND CLICK WORK on Desktop & Mobile)

import React, { useState, useRef, useEffect } from 'react';
import { projectCategories } from './projectData';
// import squadaLogo from './images/squadaLogoBanner.png';
import squadaLogo from './images/squadaLogoBannerDCB.png';
import './styles.css'; 
import './index.css'; 
import './App.css'; 

const Projects = () => {
  const [showModal, setShowModal] = useState(null);
  const modalRef = useRef();

  const openModal = (modalType) => {
    setShowModal(modalType);
  };

  const closeModal = () => {
    setShowModal(null);
    document.body.style.overflow = 'auto';
  };

  const handleOutsideClick = (e) => {
    if (
      modalRef.current &&
      !modalRef.current.contains(e.target) &&
      e.target.closest('.modal-content') === null
    ) {
      closeModal();
    }
  };

  const handleCategoryClick = (category) => {
    openModal(category.toLowerCase());
  };

  const handleModalCloseMobile = (e) => {
    if (e.touches.length === 1) {
      // Ensure only a single touch is considered
      closeModal();
    }
  };

  const handleModalClose = (e) => {
    if ('ontouchstart' in window && e.type === 'click') {
      // For touch devices, if the event is a click, prevent default to avoid double-triggering
      e.preventDefault();
    }

    closeModal();
  };

  useEffect(() => {
    // Use touch events for mobile devices
    const clickEvent = 'ontouchstart' in window ? 'touchstart' : 'mousedown';

    document.addEventListener(clickEvent, handleOutsideClick);

    // Cleanup the event listener when the component unmounts
    return () => {
      document.removeEventListener(clickEvent, handleOutsideClick);
    };
  }, []);

  const Modal = ({ title, content }) => (
    <div className='modal' onClick={handleOutsideClick}>
      <div ref={modalRef} className='modal-content' onClick={(e) => e.stopPropagation()}>
        <button
          className='absolute top-4 right-4 text-gray-700 hover:text-gray-300 transition border border-gray-300 p-2 rounded-md cursor-pointer'
          onClick={handleModalClose}
          // onClick={handleModalCloseMobile}
          onTouchStart={handleModalCloseMobile}
        >
          <svg className='w-6 h-6' fill='none' stroke='currentColor' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
            <path strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M6 18L18 6M6 6l12 12'></path>
          </svg>
        </button>
        <h2 className='text-3xl font-semibold mb-4 text-center text-white'>{title}</h2>
        <div className='grid grid-cols-1 sm:grid-cols-2 gap-6'>{content}</div>
      </div>
    </div>
  );

  return (
    <section className='max-container'>
      <img src={squadaLogo} alt='SQUADA Logo' className='object-contain' />
      <p className='text-lg text-gray-400 text-center mt-4'> 
        Artist + Developer + Entrepreneur
      </p>

      {/*  Buttons Modals */}
      <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-8'>
        {projectCategories.map((category) => (
          <button
            key={category.category}
            className='modal-trigger-button' 
            onClick={() => handleCategoryClick(category.category)}

            onTouchEnd={() => handleCategoryClick(category.category)}
          >
            {category.category}
          </button>
        ))}
      </div>
    


       {/* Render Modals based on showModal state */}
       {projectCategories.map((category) => (
        showModal === category.category.toLowerCase() && (
          <Modal
            key={category.category}
            title={category.category}
            content={category.projects.map((project) => (
              <div
                key={project.name}
                className='p-4 border border-gray-300 rounded-md mb-4 project-item hover:bg-gray-100 transition'
                onClick={() => window.open(project.url, '_blank')} // Open URL on click
                onTouchEnd={() => window.open(project.url, '_blank')} // Open URL on touch
              >
                <h3 className='text-lg font-semibold text-center'>{project.name}</h3>
              </div>
            ))}
          >
            <button className="close-button"

              onClick={handleModalCloseMobile}  // NEW
              onTouchStart={handleModalCloseMobile} // Use onTouchStart instead

            >
              <svg className='w-6 h-6' fill='none' stroke='currentColor' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
                <path strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M6 18L18 6M6 6l12 12'></path>
              </svg>
            </button>
          </Modal>
        )
      ))}
    </section>
  );
};

export default Projects;